import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ApolloProvider, } from "@apollo/client";
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import { client, } from "./apollo";
import App from './App';
import { configureStore } from './redux/Store';
import Spinner from './views/spinner/Spinner';

const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_CENTER,
  timeout: 3000,
  offset: '100px',
  // you can also just use 'scale'
  transition: transitions.SCALE
}


ReactDOM.render(
  <ApolloProvider client={client}>
  <Provider store={configureStore()}>
    <Suspense fallback={<Spinner />}>
        <BrowserRouter>
        <AlertProvider template={AlertTemplate} {...options}>
            <App />
            </AlertProvider>
      </BrowserRouter>
    </Suspense>
    </Provider>
  </ApolloProvider>
    ,
  document.getElementById('root'),
);

// If you want to enable client cache, register instead.


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
